import React from "react";
import KnowledgeBackedProfileChapter from "./KnowledgeBackedProfileChapter";

// Health & Care-specific classification, copy, and manager destinations stay
// in healthCareDomain.js. The shared shell only forwards manager navigation.
const ProfileHealthCareChapter = (props) => (
  <KnowledgeBackedProfileChapter {...props} presentationMode="profileItems" showGroupHeadings />
);

export default ProfileHealthCareChapter;
